"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailReducer = void 0;
var DetailAction_1 = require("@/pages/detail/actions/DetailAction");
var DetailGalleryAction_1 = require("@/pages/detail/actions/DetailGalleryAction");
var NearbyAction_1 = require("@/pages/detail/actions/NearbyAction");
var DetailState_init_1 = require("@/pages/detail/states/DetailState.init");
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var typesafe_actions_1 = require("typesafe-actions");
var VideoAction_1 = require("@/pages/detail/actions/VideoAction");
exports.detailReducer = function (state, action) {
    if (state === void 0) { state = DetailState_init_1.defaultDetailState; }
    switch (action.type) {
        case typesafe_actions_1.getType(PlaceAction_1.default.setSort): {
            return __assign(__assign(__assign({}, state), { similar: __assign(__assign({}, state.similar), { currentSort: action.payload.field }) }), (state.sameBuilding ? {
                sameBuilding: __assign(__assign({}, state.sameBuilding), { currentSort: action.payload.field })
            } : {}));
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setOrder): {
            return __assign(__assign(__assign({}, state), { similar: __assign(__assign({}, state.similar), { currentOrder: action.payload.order }) }), (state.sameBuilding ? {
                sameBuilding: __assign(__assign({}, state.sameBuilding), { currentOrder: action.payload.order })
            } : {}));
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setAvailableItemIsSaved): {
            return __assign(__assign({}, state), { similar: __assign(__assign({}, state.similar), { results: state.similar.results.map(function (it) { return (Number(it.referenceId) === Number(action.payload.id)) ? (__assign(__assign({}, it), { isSaved: action.payload.state })) : it; }) }) });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setAvailableItemsIsSaved): {
            return __assign(__assign({}, state), { similar: __assign(__assign({}, state.similar), { results: state.similar.results
                        .map(function (it) { return action.payload.ids.map(function (it) { return Number(it); })
                        .indexOf(Number(it.referenceId)) >= 0 ? (__assign(__assign({}, it), { isSaved: action.payload.state })) : it; }) }) });
        }
        case typesafe_actions_1.getType(DetailGalleryAction_1.default.setGalleryIndex): {
            if (action.payload.id === 'detail') {
                return __assign(__assign({}, state), { gallery: __assign(__assign({}, state.gallery), { currentIndex: action.payload.index }) });
            }
            if (action.payload.id === 'detailgallery') {
                return __assign(__assign({}, state), { galleryPhotos: __assign(__assign({}, state.galleryPhotos), { currentIndex: action.payload.index }) });
            }
            if (action.payload.id === 'detailfloorplan') {
                return __assign(__assign({}, state), { galleryFloorPlans: __assign(__assign({}, state.galleryFloorPlans), { currentIndex: action.payload.index }) });
            }
            return state;
        }
        case typesafe_actions_1.getType(DetailGalleryAction_1.default.setPortrait): {
            if (action.payload.id === 'detail') {
                return __assign(__assign({}, state), { gallery: __assign(__assign({}, state.gallery), { items: state.gallery.items.map(function (it, i) {
                            if (i === action.payload.index) {
                                return __assign(__assign({}, it), { isPortrait: action.payload.isPortrait });
                            }
                            return it;
                        }) }) });
            }
            if (action.payload.id === 'detailgallery') {
                return __assign(__assign({}, state), { galleryPhotos: __assign(__assign({}, state.galleryPhotos), { items: state.galleryPhotos.items.map(function (it, i) {
                            if (i === action.payload.index) {
                                return __assign(__assign({}, it), { isPortrait: action.payload.isPortrait });
                            }
                            return it;
                        }) }) });
            }
            if (action.payload.id === 'detailfloorplan') {
                return __assign(__assign({}, state), { galleryFloorPlans: __assign(__assign({}, state.galleryFloorPlans), { items: state.galleryFloorPlans.items.map(function (it, i) {
                            if (i === action.payload.index) {
                                return __assign(__assign({}, it), { isPortrait: action.payload.isPortrait });
                            }
                            return it;
                        }) }) });
            }
            return state;
        }
        case typesafe_actions_1.getType(DetailAction_1.default.setPopActive): {
            return __assign(__assign({}, state), { popActiveTab: action.payload });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.setPopRender): {
            return __assign(__assign({}, state), { popRender: action.payload });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setMapObjects): {
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { big: __assign(__assign({}, state.nearbyMap.big), { objects: action.payload }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setSmallMapObjects): {
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { small: __assign(__assign({}, state.nearbyMap.small), { objects: action.payload }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setNearbyProperties): {
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { big: __assign(__assign({}, state.nearbyMap.big), { properties: action.payload }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.onFilterClick): {
            return __assign(__assign({}, state), { popNearbyTab: action.payload, nearbyMap: __assign(__assign({}, state.nearbyMap), { big: __assign({}, state.nearbyMap.big) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setNearbyMore): {
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { big: __assign(__assign({}, state.nearbyMap.big), { popNearbyMore: action.payload }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setSavedPlaces): {
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { big: __assign(__assign({}, state.nearbyMap.big), { savedPlaces: action.payload }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setMapZoom): {
            var newMapState = action.payload.center
                ? __assign(__assign({}, state.nearbyMap.big.mapState), { zoom: action.payload.zoom, center: action.payload.center }) : __assign(__assign({}, state.nearbyMap.big.mapState), { zoom: action.payload.zoom });
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { big: __assign(__assign({}, state.nearbyMap.big), { mapState: newMapState }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setSmallMapZoom): {
            var newMapState = action.payload.center
                ? __assign(__assign({}, state.nearbyMap.small.mapState), { zoom: action.payload.zoom, center: action.payload.center }) : __assign(__assign({}, state.nearbyMap.small.mapState), { zoom: action.payload.zoom });
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { small: __assign(__assign({}, state.nearbyMap.small), { mapState: newMapState }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setMapCenter): {
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { big: __assign(__assign({}, state.nearbyMap.big), { mapState: __assign(__assign({}, state.nearbyMap.big.mapState), { center: action.payload }) }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setSmallMapCenter): {
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { small: __assign(__assign({}, state.nearbyMap.small), { mapState: __assign(__assign({}, state.nearbyMap.small.mapState), { center: action.payload }) }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setResultItems): {
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { big: __assign(__assign({}, state.nearbyMap.big), { results: action.payload.results }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.showAddPlace): {
            return __assign(__assign({}, state), { isNearbyEstimatorShowing: action.payload });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setKeyword): {
            return __assign(__assign({}, state), { nearbyEstimator: __assign(__assign({}, state.nearbyEstimator), { keyword: action.payload }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setSuggestons): {
            return __assign(__assign({}, state), { nearbyEstimator: __assign(__assign({}, state.nearbyEstimator), { suggestions: action.payload }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setIsSuggesting): {
            return __assign(__assign({}, state), { nearbyEstimator: __assign(__assign({}, state.nearbyEstimator), { isSuggesting: action.payload }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setSelectedPlace): {
            return __assign(__assign({}, state), { nearbyEstimator: __assign(__assign({}, state.nearbyEstimator), { selectedPlace: action.payload }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setIsSelecting): {
            return __assign(__assign({}, state), { nearbyEstimator: __assign(__assign({}, state.nearbyEstimator), { isSelecting: action.payload }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setCommuteMethod): {
            return __assign(__assign({}, state), { nearbyEstimator: __assign(__assign({}, state.nearbyEstimator), { commuteMethod: action.payload }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setResultItemDurations): {
            var durations_1 = action.payload.durations;
            var newResults = state.nearbyMap.big.results.map(function (it, i) {
                if (i !== action.payload.i)
                    return it;
                return __assign(__assign({}, it), { durations: durations_1 });
            });
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { big: __assign(__assign({}, state.nearbyMap.big), { results: newResults }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setMyPlaceDurations): {
            var durations_2 = action.payload.durations;
            var newSavedPlaces = state.nearbyMap.big.savedPlaces.map(function (it, i) {
                if (i !== action.payload.i)
                    return it;
                return __assign(__assign({}, it), { durations: durations_2 });
            });
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { big: __assign(__assign({}, state.nearbyMap.big), { savedPlaces: newSavedPlaces }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setResultItemActive): {
            var newResults = state.nearbyMap.big.results.map(function (it, i) {
                if (i !== action.payload.i) {
                    return __assign(__assign({}, it), { active: false });
                }
                return __assign(__assign({}, it), { active: action.payload.state });
            });
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { big: __assign(__assign({}, state.nearbyMap.big), { results: newResults }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setMyPlaceItemActive): {
            var newSavedPlaces = state.nearbyMap.big.savedPlaces.map(function (it, i) {
                if (i !== action.payload.i) {
                    return __assign(__assign({}, it), { active: false });
                }
                return __assign(__assign({}, it), { active: action.payload.state });
            });
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { big: __assign(__assign({}, state.nearbyMap.big), { savedPlaces: newSavedPlaces }) }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setSuggestionPostion): {
            var newSuggestions = state.nearbyEstimator.suggestions.map(function (it) {
                if (it.placeId === action.payload.placeId) {
                    return __assign(__assign({}, it), { position: action.payload.position });
                }
                return it;
            });
            return __assign(__assign({}, state), { nearbyEstimator: __assign(__assign({}, state.nearbyEstimator), { suggestions: newSuggestions }) });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setNewPlaceTravalDuration): {
            return __assign(__assign({}, state), { nearbyEstimator: __assign(__assign({}, state.nearbyEstimator), { durationValue: action.payload.value, durationUnit: action.payload.unit }) });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.setMortgage): {
            return __assign(__assign({}, state), { mortgage: __assign(__assign({}, state.mortgage), action.payload) });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.onPriceChange): {
            return __assign(__assign({}, state), { mortgage: __assign(__assign({}, state.mortgage), { price: action.payload.value }) });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.onDownPaymentChange): {
            return __assign(__assign({}, state), { mortgage: __assign(__assign({}, state.mortgage), { downPayment: action.payload.value }) });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.onDurationChange): {
            return __assign(__assign({}, state), { mortgage: __assign(__assign({}, state.mortgage), { durationInMonth: action.payload.value }) });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.onInterestRateChange): {
            return __assign(__assign({}, state), { mortgage: __assign(__assign({}, state.mortgage), { interestRate: action.payload.value }) });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.onBsdChange): {
            return __assign(__assign({}, state), { mortgage: __assign(__assign({}, state.mortgage), { buyerStampDuty: action.payload.value }) });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.onAvdChange): {
            return __assign(__assign({}, state), { mortgage: __assign(__assign({}, state.mortgage), { adValoremStampDuty: action.payload.value }) });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.onHasTransactedRecentlyChanged): {
            return __assign(__assign({}, state), { mortgage: __assign(__assign({}, state.mortgage), { hasTransactedRecently: action.payload.value }) });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.onHasTransactedRecentlyMonthChanged): {
            return __assign(__assign({}, state), { mortgage: __assign(__assign({}, state.mortgage), { hasTransactedRecentlyMonth: action.payload.value }) });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.onMortgageTabClick): {
            return __assign(__assign({}, state), { mortgageTab: action.payload });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.onExpandClick): {
            return __assign(__assign({}, state), { isMortgageExpand: action.payload });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.setFeatureExpand): {
            return __assign(__assign({}, state), { isFeatureExpand: action.payload });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.setIsSaved): {
            return __assign(__assign({}, state), { property: __assign(__assign({}, state.property), { isSaved: action.payload }) });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.setSticky): {
            return __assign(__assign({}, state), { isSticking: action.payload });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.setStickyContact): {
            return __assign(__assign({}, state), { isStickingContact: action.payload });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.setBuildingFollowingId): {
            return __assign(__assign({}, state), { buildingFollowingId: action.payload });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.setDistrictFollowingId): {
            return __assign(__assign({}, state), { districtFollowingId: action.payload });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.setFeatureOverflow): {
            return __assign(__assign({}, state), { isFeatureOverflow: action.payload });
        }
        case typesafe_actions_1.getType(NearbyAction_1.default.setNearbyItemIndexActive): {
            var newProperties = state.nearbyMap.big.properties.map(function (it, i) {
                if (i === action.payload) {
                    return __assign(__assign({}, it), { active: true });
                }
                return __assign(__assign({}, it), { active: false });
            });
            return __assign(__assign({}, state), { nearbyMap: __assign(__assign({}, state.nearbyMap), { big: __assign(__assign({}, state.nearbyMap.big), { properties: newProperties }) }) });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.setNavBackUrl): {
            return __assign(__assign({}, state), { navBackUrl: action.payload });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.setDonutActive): {
            return __assign(__assign({}, state), { mortgage: __assign(__assign({}, state.mortgage), { activeIndex: action.payload }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setIsPlaying): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { isPlaying: action.payload }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setIsMuted): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { isMuted: action.payload }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setCurrentTime): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { currentTime: action.payload }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setTotalTime): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { totalTime: action.payload }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setTargetCurrent): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { targetCurrent: action.payload }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setVideoId): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { id: action.payload }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setVideoTitleCaption): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { title: action.payload.title, caption: action.payload.caption }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setVideoPlayerOverlayActive): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { overlayActive: action.payload }) });
        }
    }
    return state;
};
